const loadFloorPlans = () => {
    const floorPlanLinks = document.querySelectorAll('.room-floor-plan-link')

    for (let floorPlanLink of floorPlanLinks) {
        floorPlanLink.addEventListener('click', event => {
            event.preventDefault()

            // Display background overlay
            document.body.classList.add('.modal-visible')

            // Find floor plan container
            const floorPlanId = floorPlanLink.getAttribute('data-launch-id')
            const floorPlan = document.querySelector(`[data-floor-plan="${floorPlanId}"]`)
            const floorPlanClose = document.querySelector(`[data-floor-plan-close="${floorPlanId}"]`)

            // Show floor plan
            floorPlan.classList.add('visible')

            // Hide background overlay and floor plan on close click
            floorPlanClose.addEventListener('click', () => {
                document.body.classList.remove('.modal-visible')
                floorPlan.classList.remove('visible')
            })
        })
    }
}

export default loadFloorPlans



// WEBPACK FOOTER //
// ./js/floorPlans.js